import { Show } from "solid-js"
import { Icon } from "../components/icon"
import { Tooltip } from "../components/tooltip"
import {
  navigationButtonClass,
  navigationButtonsContainerClass,
} from "./post-navigation.css"

export type NavPost = { id: string; title: string | null; cursor: string }

export function PostNavigation(props: {
  previousPost: NavPost | null
  nextPost: NavPost | null
  previousLabel: string
  nextLabel: string
  buildPostUrl: (post: NavPost) => string
}) {
  return (
    <div class={navigationButtonsContainerClass}>
      <Show
        when={props.previousPost}
        fallback={
          <span class={navigationButtonClass}>
            <Icon name="arrow-up" size="18" color="sand800" />
          </span>
        }
      >
        {prev => (
          <Tooltip description={props.previousLabel} placement="left">
            <a href={props.buildPostUrl(prev())} class={navigationButtonClass}>
              <Icon name="arrow-up" size="18" color="sand800" />
            </a>
          </Tooltip>
        )}
      </Show>
      <Show
        when={props.nextPost}
        fallback={
          <span class={navigationButtonClass}>
            <Icon name="arrow-down" size="18" color="sand800" />
          </span>
        }
      >
        {next => (
          <Tooltip description={props.nextLabel} placement="left">
            <a href={props.buildPostUrl(next())} class={navigationButtonClass}>
              <Icon name="arrow-down" size="18" color="sand800" />
            </a>
          </Tooltip>
        )}
      </Show>
    </div>
  )
}
